import createIcon from '../../createIcon';

/**
 * @component @name Flare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxMUgxVjEzSDdWMTFaTTkuMTcgNy43Nkw3LjA1IDUuNjRMNS42NCA3LjA1TDcuNzYgOS4xN0w5LjE3IDcuNzZaTTEzIDFIMTFWN0gxM1YxWk0xOC4zNiA3LjA1TDE2Ljk1IDUuNjRMMTQuODMgNy43NkwxNi4yNCA5LjE3TDE4LjM2IDcuMDVaTTE3IDExVjEzSDIzVjExSDE3Wk0xMiA5QzEwLjM0IDkgOSAxMC4zNCA5IDEyQzkgMTMuNjYgMTAuMzQgMTUgMTIgMTVDMTMuNjYgMTUgMTUgMTMuNjYgMTUgMTJDMTUgMTAuMzQgMTMuNjYgOSAxMiA5Wk0xNC44MyAxNi4yNEwxNi45NSAxOC4zNkwxOC4zNiAxNi45NUwxNi4yNCAxNC44M0wxNC44MyAxNi4yNFpNNS42NCAxNi45NUw3LjA1IDE4LjM2TDkuMTcgMTYuMjRMNy43NiAxNC44M0w1LjY0IDE2Ljk1Wk0xMSAyM0gxM1YxN0gxMVYyM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Flare = createIcon('Flare', [
  [
    'path',
    {
      d: 'M7 11H1V13H7V11ZM9.17 7.76L7.05 5.64L5.64 7.05L7.76 9.17L9.17 7.76ZM13 1H11V7H13V1ZM18.36 7.05L16.95 5.64L14.83 7.76L16.24 9.17L18.36 7.05ZM17 11V13H23V11H17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9ZM14.83 16.24L16.95 18.36L18.36 16.95L16.24 14.83L14.83 16.24ZM5.64 16.95L7.05 18.36L9.17 16.24L7.76 14.83L5.64 16.95ZM11 23H13V17H11V23Z',
      key: '112u9n',
    },
  ],
]);

export default Flare;
